export const blockIconsSocialGroups = (
	<span className='material-symbols-outlined'>groups</span>
);
